/**
 * @generated SignedSource<<ce37a409560fe2323da16d36f7d8cb4d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MembershipPlanSelectSection_OrganizationFragment$data = {
  readonly id: string;
  readonly viewerMembershipPlan: {
    readonly id: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"MembershipPlanSelectButton_OrganizationFragment">;
  readonly " $fragmentType": "MembershipPlanSelectSection_OrganizationFragment";
};
export type MembershipPlanSelectSection_OrganizationFragment$key = {
  readonly " $data"?: MembershipPlanSelectSection_OrganizationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MembershipPlanSelectSection_OrganizationFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MembershipPlanSelectSection_OrganizationFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "viewerMembershipPlan",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MembershipPlanSelectButton_OrganizationFragment"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "e749a6477e073558dc0cf0775197751c";

export default node;
